import React from 'react';
import Component from '@plone/volto/components/theme/Component/Component';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { FormattedMessage, useIntl } from 'react-intl';
import { messages as personMessages } from '../../../components/Person/PersonMetadata';
import Summary from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import Obfuscate from 'react-obfuscate';

const CustomProjectListingItemTemplate = ({ item, isEditMode }) => {
  const intl = useIntl();
  const taxo_classification = useSelector(
    (state) => state.taxonomies?.['collective.taxonomy.classification'],
  );

  const language = useSelector((state) => state.intl.locale);

  const getTaxonomyTitle = (token, taxonomy) => {
    if (taxonomy && taxonomy.data?.tree) {
      const term = taxonomy.data.tree.find((term) => term.key === token);
      return term ? term.translations?.[language] ?? term.title : token;
    }
  };

  const itemTitle = item?.shortTitle ? item.shortTitle : item.title;
  const changed_title_item = {
    ...item,
    title: itemTitle,
  };

  return (
    <>
      <div className="listing-body">
        <Summary
          item={changed_title_item}
          HeadingTag="h3"
          hide_description={
            !changed_title_item.Description ||
            (changed_title_item.Description &&
              changed_title_item.Description.trim() === '')
          }
        />
        <ConditionalLink
          item={changed_title_item}
          condition={!isEditMode}
          className="listing-readmore"
        >
          <FormattedMessage id="listing.readmore.more" defaultMessage="Mehr" />
        </ConditionalLink>
      </div>
      <div className="preview-image-wrapper">
        <Component
          componentName="PreviewImage"
          item={changed_title_item}
          alt={
            changed_title_item?.image_alternative_text ??
            'Teaserbild eines Projektes'
          }
        />
      </div>
    </>
  );
};

export default CustomProjectListingItemTemplate;
